import { ReactNode } from "react";

interface PageTransitionProps {
  children: ReactNode;
}

// A plain CSS fade-in on route change (see .page-transition in index.css).
// This used to be framer-motion, which put the largest library in the main
// bundle just for a 250ms opacity tween — expensive to parse on phones.
const PageTransition = ({ children }: PageTransitionProps) => (
  <div className="page-transition w-full">{children}</div>
);

export default PageTransition;
